'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:flight:gotoAppHomepage');
}

var _invoke = require('../invoke');

/**
 * 返回 app 首页
 *
 * @memberof flight
 * @static
 * @name gotoAppHomepage
 * @return {Undefined}
 * @example
 *  hbnb.flight.gotoAppHomepage();
 */
module.exports = function() {
    if (process.env.NODE_ENV !== 'production') {
        debug('called');
    }

    _invoke('flight', 'goto_app_homepage');
};



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/flight/goto-app-homepage.js
// module id = 577
// module chunks = 0